module.exports = __webpack_public_path__ + "media/1_1-7.6eb96da1.mp3";